// Inicializácia Firebase (konfigurácia sa načítava z .env v koreni projektu).
// Firestore sa používa na zľavové kupóny – kódy tak nie sú súčasťou
// verejného JS bundle a majú serverovo strážený počet použití / platnosť.
// Firestore SDK sa načítava lenivo (až pri overení kupónu), aby nezväčšoval
// hlavný bundle – viď getDb() nižšie.

import { initializeApp, getApps } from 'firebase/app';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

/** Lenivé načítanie Firestore – SDK sa stiahne až pri prvom použití. */
export async function getDb() {
  const { getFirestore } = await import('firebase/firestore');
  return getFirestore(app);
}

// Analytics len v prehliadači a len ak je podporovaná (v testoch sa preskočí).
if (typeof window !== 'undefined') {
  import('firebase/analytics')
    .then(({ getAnalytics, isSupported }) =>
      isSupported().then((supported) => supported && getAnalytics(app))
    )
    .catch(() => {});
}

export default app;
